import React, { useEffect, useState } from 'react';
import { Spinner, Tab, Tabs } from 'react-bootstrap';
import { IoMdCloseCircle } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { wisdomSliceAction } from '../../store/wisdom';
import emptybox from "./../../assets/images/empty-box.png";
import { checkWisdomEnabled } from '../../utils/utils';
import DOMPurify from 'dompurify';


const Wisdom = () => {
    const dispatch = useDispatch()
    const agentObj = useSelector((state:any)=>{return state.agentSlice.agentObj})
    const contactAttributes = useSelector((state:any)=>{return state.contactAttributeSlice?.contactAttributes})
    const selectedContactId = useSelector((state:any)=>{return state.contactAttributeSlice?.selectedContact})
    const selectedContact = contactAttributes?.filter((item:any) => item.contactId === selectedContactId)[0]
    const selectedContent = useSelector((state:any)=>{return state?.wisdomSlice?.wisdomData})
    const [isWisdomEnabled, setIsWisdomEnabled] = useState(false);
    const [searchItem, setSearchItem] = useState([])
    const [selectedTab, setSelectedTab] = useState("");
    const [serachLoading, setSerachLoading] = useState(false)
    const [tabLoading, setTabLoading] = useState(false)

    useEffect(()=>{
        const getDashboardData = async () => {
            if(agentObj) {
                let profileName = agentObj.getRoutingProfile().name
                let wisdomStatus = await checkWisdomEnabled(profileName)
                let sessionIdAndAssistantId = await checkSessionIdAndAssistantId()
                if(wisdomStatus && sessionIdAndAssistantId) {
                    setIsWisdomEnabled(true)
                } else {
                    setIsWisdomEnabled(false)
                }
            }
        }
        getDashboardData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[agentObj, selectedContact])

    const checkSessionIdAndAssistantId = async () => {
        if(selectedContact) {
            let result = (selectedContact?.contactAttributes?.assistantId?.value && selectedContact?.contactAttributes?.sessionId?.value)
            return (result) ? true:false
        } else {
            return false; 
        }
    }

    const onSearchRecommendations = async (event:any) => {
        if(!event.target.value) return;
        setSerachLoading(true)
        let searchQuery = event.target.value;
        const responseData = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}Wisdom`, {
            method: "POST",
            body: JSON.stringify({
                Action: "Search",
                Term: searchQuery,
                sessionId: selectedContact?.contactAttributes?.sessionId?.value,
                assistantId: selectedContact?.contactAttributes?.assistantId?.value,
            }),
        }).then(resp => resp.json());
        if(responseData){
            const items = responseData.results.map((result: any) => {
                return {
                    title_text: result.document.title.text,
                    excerpt_html: result.document.excerpt.text,
                    kb_id: result.document.contentReference.knowledgeBaseId,
                    content_id: result.document.contentReference.contentId,
                };
            });
            setSearchItem(items)
            setSerachLoading(false)
        } else {
            setSerachLoading(false)
        }
    }

    const onSelectSearchItem = async (selectedItem:any) => {
        setTabLoading(true)
        setSearchItem([])
        setSelectedTab(selectedItem.content_id)
        let isContectExist = selectedContent?.filter((content:any) => selectedItem.content_id === content.content_id)[0]
        if(!isContectExist) {
            const KBContent = await fetch(`${process.env.REACT_APP_API_GETWAY_URL}Wisdom`, {
                method: "POST",
                body: JSON.stringify({
                    Action: "GetKBContent",
                    contentId: selectedItem.content_id,
                    knowledgeBaseId: selectedItem.kb_id,
                }),
            }).then((resp) => resp.json())
            
            if(KBContent){
                const articles = await fetch(KBContent.content.url).then((resp) => resp.json())
                let insertData = {content_id: selectedItem.content_id, title_text:selectedItem.title_text, text:articles.text};
                setTabLoading(false)
                dispatch(wisdomSliceAction.setWisdomData([...selectedContent,insertData]))
            } else {
                setTabLoading(false)
            }
        } else {
            setTabLoading(false)
        }
    }

    const onRemoveContent = (contentId:any) => {
        const remainingContent:any = selectedContent.filter((content:any) => {
            return contentId !== content.content_id
        })
        dispatch(wisdomSliceAction.setWisdomData(remainingContent))
    }

    const onTabChange = (contactId:any) => {
        setSelectedTab(contactId)
    }
    return (
        <React.Fragment>
            {isWisdomEnabled && 
                <div className="card wisdom-box collapse show mt-3" id="wisdom">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h6 className='m-0'>Wisdom</h6>
                        <div className='d-flex'>
                            <div className='search-wisdom'>
                                <input className="form-control" placeholder="Search" onChange={onSearchRecommendations} />
                                <ul className="search-wisdom-list list-group">
                                    {serachLoading && <li className="list-group-item"><Spinner animation="border" size="sm" /> Searching...</li>}
                                    {searchItem && searchItem.map((item:any,index:number) =>{
                                        return (<li key={index} onClick={() => {onSelectSearchItem(item)}} className="list-group-item">{item.title_text}</li>)
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="card-body min-height-400">
                        
                        <div className="col-md-12">
                            {tabLoading && <label><Spinner animation="border" size="sm" /> Loading...</label>}
                            {selectedContent.length > 0 && 
                                <Tabs activeKey={selectedTab} onSelect={(k:any) => onTabChange(k)}>
                                    {selectedContent.map((content:any) => {
                                        return (
                                            <Tab key={content.content_id} eventKey={content.content_id} title={<span>{content.title_text} <IoMdCloseCircle onClick={()=>{onRemoveContent(content.content_id)}} size={24}/></span>}>
                                                <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(content.text)}}></div>
                                            </Tab>
                                        )
                                    })}
                                </Tabs>
                            }
                        </div>
                        {selectedContent.length <= 0 &&
                            <div className='empty-data'>
                                <img className='empty-icon' src={emptybox} alt="empty box icon" />
                                <h4>No data available</h4>
                            </div>
                        }
                    </div>
                </div>
            }
        </React.Fragment>     
    )
}
export default Wisdom;